import {required} from "vuelidate/lib/validators";

export const loginValidation = {
    email_user_name: {required},
    password: {required}
}
